var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm12: "", md12: "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    {
                      staticStyle: {
                        "padding-top": "1px",
                        "padding-bottom": "1px"
                      },
                      attrs: { "primary-title": "" }
                    },
                    [
                      _c("v-text-field", {
                        staticStyle: { height: "50px" },
                        attrs: {
                          "append-icon": "search",
                          label: "Buscar...",
                          "single-line": "",
                          "hide-details": ""
                        },
                        on: { input: _vm.onFilterTextBoxChanged },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "grilla" },
                    [
                      _c("grid", {
                        staticClass: "ag-theme-material",
                        staticStyle: {
                          width: "100%",
                          height: "auto",
                          "font-family": "'Asap', sans-serif"
                        },
                        attrs: {
                          "data-testid": "test__unidad",
                          gridOptions: _vm.gridOptions,
                          getRowNodeId: _vm.getRowNodeId,
                          rowData: _vm.vehiculos,
                          animateRows: false,
                          deltaRowDataMode: true,
                          suppressCopyRowsToClipboard: "true",
                          "funcionalidad-id": _vm.funcionalidad
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    { staticStyle: { padding: "10px", "text-align": "right" } },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "13px",
                            "padding-right": "10px"
                          }
                        },
                        [
                          _vm._v(
                            "Mostrando " +
                              _vm._s(_vm.cantidadVehiculos) +
                              " vehículos"
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }